import React from 'react';
import {useSelector} from 'react-redux';
import './SuccubesAbilitiesToolbar.css'
import {StatWell} from "../../../../gameUi/StatWell";
import {
  SUCCUBES_SEDUCTION_COST,
  SUCCUBES_SEDUCTION_RANGE,
  SUCCUBES_SEDUCTION_RESULT_COLOR
} from "../../../../../configs/factions/succubes";
import {selectPlayers, selectSelectedUnit} from "../../../../../redux/reducers/sharedStateReducer/selectors";
import {MaskedIcon} from "../../../../coloredIcons/MaskedIcon/MaskedIcon";
import {
  CombatDuel,
  CombatEquation,
  CombatName,
  CombatPanel,
  CombatToken,
  CombatUnitToken,
  getCombatUnitIconProps,
} from "../../../CombatPanel/CombatPanel";

// Пассивная подсказка на этапе способностей: сам выбор цели и бросок
// происходят кликом по гексу с целью (см. GameScene.handleAbilitiesPhaseClick),
// а не кнопками тулбара — по образцу подсветки целей у стрельбы, а не у
// кнопочного списка целей Лепреконов. Стоимость показывается ДО попытки —
// монеты списываются независимо от исхода (см. design.md Decision 15). Вид — как у
// панели результата соблазнения, только на месте цели пока вопрос
const SuccubesAbilitiesToolbar = () => {
  const selectedUnit = useSelector(selectSelectedUnit);
  const players = useSelector(selectPlayers);

  if (!selectedUnit) {
    return null;
  }

  return (
    <CombatPanel
      key={selectedUnit.id}
      className={'succubes-abilities-toolbar'}
      toneColor={SUCCUBES_SEDUCTION_RESULT_COLOR}
      duel={(
        <CombatDuel
          actor={<CombatUnitToken unitType={selectedUnit.type} iconProps={getCombatUnitIconProps(selectedUnit, players)}/>}
          actionIcon={<MaskedIcon src={'/img/icons/ability.png'} alt={'Соблазнение'} title={'Соблазнение'} color={SUCCUBES_SEDUCTION_RESULT_COLOR}/>}
          targets={[(
            <CombatToken key={'target'} isTarget={true}>
              <span className={'succubes-abilities-toolbar_question'}>{'?'}</span>
            </CombatToken>
          )]}
        />
      )}
    >
      <CombatName>{'Соблазнение'}</CombatName>
      <CombatEquation className={'succubes-abilities-toolbar_hint'}>
        <span>{`Выберите цель в радиусе ${SUCCUBES_SEDUCTION_RANGE} ячеек`}</span>
      </CombatEquation>
      <div className={'succubes-abilities-toolbar_cost'}>
        {'Попытка:'}
        <StatWell icon={'/img/icons/coins.png'} value={SUCCUBES_SEDUCTION_COST} title={'Стоимость попытки'}/>
      </div>
    </CombatPanel>
  );
};

export default SuccubesAbilitiesToolbar;
